import ApiUtils from "../ApiUtils";
import authStore from "../../../core/services/authStore/authStore";

export default class ApiCommonService {

    async getCompanies(doApiCall = false) {
        if(authStore.getters.allCompanies.data && !doApiCall){
            return authStore.getters.allCompanies;
        }
        else{
            const companyList = await ApiUtils.callApi('common/company/list','get');
            if(companyList){
                companyList.data.data = companyList.data.data.filter(company => company.name != null)
                authStore.commit('setCompanyList',companyList);
                return companyList;
            }
        }
    }

    async getCompanyLocations(companyId,keyword = '',state = [0]) {
        const formData = new FormData();
        formData.append('company_id',companyId);
        formData.append('keyword',keyword);
        formData.append('state',state);
        return await ApiUtils.callApi('common/company/locations','post',formData);
    }

    async getAllCompanyLocations(companyId) {
        return await ApiUtils.callApi(`common/company/locations/all/${companyId}`,'get');
    }

    async getAllclassTopics(){
        return await ApiUtils.callApi('common/class/topics','get');
    }

    async getAllclassTopicCategory(){
        return await ApiUtils.callApi('common/class/topic/category','get');
    }

    async getAllInstructors(showActiveOnly = true) {
        const url = `common/get-instructors`+(showActiveOnly ? '?active=1' : '')
        return await ApiUtils.callApi(url,'get');
    }

    async getToolGroupPermissions(toolGroupId){
        return await ApiUtils.callApi(`common/admin-tool/group/access/${toolGroupId}`,'get');
    }
}
